'use client';

import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { StatusNotification } from '../../../StatusNotification/StatusNotification';
import type { BundleAssignationFailureReason } from '../../types';
import { assignationErrorConfig } from './assignationErrorConfig';

const OfferNotEligible = ({ errorCode }: { errorCode?: BundleAssignationFailureReason }) => {
  const router = useRouter();
  const tMessages = useTranslations('offers.page.errors.message');
  const tCta = useTranslations('offers.page.errors.cta');
  const errorConfig = assignationErrorConfig[errorCode ?? 'PLAYER_NOT_QUALIFIED'];

  const onButtonClick = () => {
    router.push(errorConfig.buttonUrl ?? '');
  };

  return (
    <StatusNotification
      type={errorConfig.type}
      description={tMessages(errorConfig.message)}
      buttonText={errorConfig.buttonText ? tCta(errorConfig.buttonText) : undefined}
      onClick={onButtonClick}
      dataTrackType="Ineligible Promotion"
      dataTrackMessage={tMessages(errorConfig.message)}
    />
  );
};

export { OfferNotEligible };
